// import { lazy } from "react";
import React, { useEffect, useState } from "react";
import { Typography, Grid, Button, styled, Box } from "@mui/material";
import { Divider, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";

import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import HomeIcon from "@mui/icons-material/Home";
import { hasPermission } from "../../service/authService";

const MyCustomButton = styled(Button)(({ theme }) => ({
  fontFamily: "Motiva Sans Bold",
  fontSize: "0.80rem",
  fontWeight: "700",
  border: "1px solid #edf3f5",
  borderRadius: "4px",
  background: "#2E186A",
  boxShadow: "0 16px 30px rgb(23 31 114 / 20%)",
  marginTop: "1rem",
  "&:hover": {
    color: "#fff",
    border: "1px solid rgb(255, 130, 92)",
    backgroundColor: "rgb(255, 130, 92)",
  },
}));

const PaperCard = (props: any) => {
  return (
    <>
      <Paper
        sx={{
          boxShadow: "0 3px 5px 2px rgba(0, 0, 0, .3)",
          position: "relative",
          borderRadius: 2,
          padding: (theme) => theme.spacing(1, 2),
          width: "60%",
          margin: (theme) => theme.spacing(2),
        }}
      >
        <Grid container>
          <Grid
            container
            sx={{
              padding: (theme) => theme.spacing(1),
              // margin: (theme) => theme.spacing(1),
            }}
            flexDirection={"row"}
            justifyContent="space-between"
          >
            {/* <Diversity2Icon style={{ fontSize: "100px" }} /> */}

            <Grid
              container
              // sx={{
              //   padding: (theme) => theme.spacing(0),
              //   margin: (theme) => theme.spacing(0),
              // }}
              flexDirection={"column"}
              alignItems={"flex-start"}
              justifyContent="flex-start"
            >
              <Typography variant="h5">
                <strong>{props.title}</strong>
              </Typography>
              <Typography variant="caption" align="left" color="text.secondary">
                {props.caption}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Divider style={{ color: "#FF825B", border: "1px solid" }} />

        <Grid
          container
          // xs
          justifyContent={"flex-start"}
          sx={{
            padding: (theme) => theme.spacing(0),
            margin: (theme) => theme.spacing(1, 0),
          }}
        >
          <MyCustomButton
            type="button"
            variant="contained"
            size="medium"
            endIcon={<ArrowCircleRightIcon />}
            onClick={props.onClick}
            disabled={props.disabled || false}
          >
            <strong>{"Proceed"}</strong>
          </MyCustomButton>
        </Grid>
      </Paper>
    </>
  );
};

const ExamsManagementHome: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      width={"100%"}
      justifyContent="center"
    >
      <Typography
        variant="h3"
        sx={{
          color: "#2E186A",
        }}
        alignSelf={"center"}
        mt={2}
      >
        <strong>Exams Management Home</strong>
      </Typography>
      <Box
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"normal"}
        p={2}
        pb={0}
      >
        <MyCustomButton
          variant="contained"
          startIcon={<HomeIcon />}
          onClick={() => navigate("/home")}
        >
          Back
        </MyCustomButton>
      </Box>
      {/* <Box
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        justifyContent={"center"}
        width={"auto"}
      >
        {hasPermission("Exams Management") && (
          <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            // justifyContent={"flex-end"}
            width={"50%"}
          >
            {hasPermission("Create New Exams") && (
              <PaperCard
                title={"Create New Exams"}
                caption={"Create and Manage Exams"}
                onClick={() => navigate("add-exams")}
              />
            )}
            <PaperCard
              title={"Exam Attendance"}
              caption={"Update Exam wise Attendance"}
              onClick={() => navigate("manage-attendance")}
            />
          </Box>
        )}
        {hasPermission("Exams Management") && (
          <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            // justifyContent={"normal"}
            width={"50%"}
          >
            {hasPermission("Schedule An Exam") && (
              <PaperCard
                title={"Schedule An Exam"}
                caption={"Schedule Term Wise Exams"}
                onClick={() => navigate("schedule-exam")}
              />
            )}
            <PaperCard
              title={"Update Marks"}
              caption={"Update Students Performance"}
              onClick={() => navigate("manage-marks")}
            />
          </Box>
        )}
        {hasPermission("Exams Management") && (
          <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            // justifyContent={"flex-start"}
            width={"50%"}
          >
            <PaperCard
              title={"Generate Admit Cards"}
              caption={"Fetch and Print Admit Card"}
              onClick={() => navigate("get-admit-card")}
              disabled={false}
            />
            <PaperCard
              title={"Results and Promotion"}
              caption={"Report Card, Promote Students"}
              onClick={() => navigate("generate-report-card")}
              disabled={false}
            />
          </Box>
        )}
      </Box> */}

      {hasPermission("Exams Management") && (
        <Box
          display="flex"
          flexWrap="wrap"
          gap={2}
          justifyContent="flex-start"
          height="60vh"
        >
          {hasPermission("Create New Exams") && (
            <Box sx={{ flexBasis: "32%" }}>
              <PaperCard
                title={"Create New Exams"}
                caption={"Create and Manage Exams"}
                onClick={() => navigate("add-exams")}
              />
            </Box>
          )}
          {hasPermission("Schedule An Exam") && (
            <Box sx={{ flexBasis: "32%" }}>
              <PaperCard
                title={"Schedule An Exam"}
                caption={"Schedule Term Wise Exams"}
                onClick={() => navigate("schedule-exam")}
              />
            </Box>
          )}
          <Box sx={{ flexBasis: "32%" }}>
            <PaperCard
              title={"Generate Admit Cards"}
              caption={"Fetch and Print Admit Card"}
              onClick={() => navigate("get-admit-card")}
              disabled={false}
            />
          </Box>
          <Box sx={{ flexBasis: "32%" }}>
            <PaperCard
              title={"Exam Attendance"}
              caption={"Update Exam wise Attendance"}
              onClick={() => navigate("manage-attendance")}
            />
          </Box>
          <Box sx={{ flexBasis: "32%" }}>
            <PaperCard
              title={"Update Marks"}
              caption={"Update Students Performance"}
              onClick={() => navigate("manage-marks")}
            />
          </Box>
          <Box sx={{ flexBasis: "32%" }}>
            <PaperCard
              title={"Results and Promotion"}
              caption={"Report Card, Promote Students"}
              onClick={() => navigate("generate-report-card")}
              disabled={false}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ExamsManagementHome;
